import api from '../../utils/api';
import {
  TCase,
  TCaseExportParams,
  TFilterCase,
  TIDVerification,
  TTrackCase
} from '../../types/cases';
import { cleanParams, serializedObject } from '../../helpers/utils';
import axios from 'axios';

const authEndpoint: string = `${process.env.REACT_APP_ENDPOINT}/case`;

const fetchAll = (filters: TFilterCase) => {
  const { flags, province_id, district_id, ...filteredFilters } = filters;
  return api.get(
    `${authEndpoint}?${serializedObject(filteredFilters)}${
      flags && `&flags[]=${flags}`
    }${province_id ? `&province_id=${province_id}` : ''}${
      district_id ? `&district_id=${district_id}` : ''
    }`
  );
};
const fetchOne = (id: string) => {
  return api.get(`${authEndpoint}/${id}`);
};
const create = (data: TCase) => {
  return api.post(`${authEndpoint}`, data);
};
const update = (id: number, data: TCase) => {
  return api.put(`${authEndpoint}/${id}`, data);
};
const destroy = (id: number) => {
  return api.delete(`${authEndpoint}/${id}`);
};
const trackCase = (data: TTrackCase) => {
  return axios.post(`${authEndpoint}/track-case`, data);
};
const fetchCount = () => {
  return api.get(`${authEndpoint}/getCount`);
};
const fetchIdVerification = (data: TIDVerification) => {
  return api.post(`${authEndpoint}/id-verification`, data);
};
const fetchFlags = () => {
  return api.get(`${authEndpoint}/getFlags`);
};
// Spec #4c §1.1 — case-list export. Same scoping/filters as fetchAll plus a
// required `format`. Returns a file blob; filename comes from the response.
const exportList = (params: TCaseExportParams) => {
  return api.get<Blob>(
    `${authEndpoint}/export?${serializedObject(cleanParams(params))}`,
    {
      responseType: 'blob'
    }
  );
};

export default {
  trackCase,
  fetchAll,
  fetchOne,
  create,
  update,
  destroy,
  fetchCount,
  fetchIdVerification,
  fetchFlags,
  exportList
};
